import { useCallback } from 'react'
import { debounce } from 'lodash'
import { useAppDispatch } from '@/state'

import {
  GetBrandsPayload,
  ListBrands,
  SaveBrandsPayload,
  UpdateBrandsPayload,
} from '@/state/brands/models'
import deleteBrandThunk from '@/state/brands/thunks/delete.thunk'
import updateBrandThunk from '@/state/brands/thunks/update.thunk'

import saveBrandThunk from '@/state/brands/thunks/save.thunk'
import { getAllBrandsThunk } from '@/state/brands/thunks/get-all.thunk'
import { BrandsActions } from '@/state/brands/slices/index.slices'

import { removeEmptyProp } from '@/utils'

export const useBrandsActions = () => {
  const dispatch = useAppDispatch()

  const getAllBrands = debounce(
    (payload: GetBrandsPayload) => {
      dispatch(getAllBrandsThunk(payload))
    },
    500, // eslint-disable-line
  )

  const saveBrand = debounce(
    async (payload: SaveBrandsPayload) => {
      const response = await dispatch(saveBrandThunk(removeEmptyProp(payload)))
      if (response.payload?.id) {
        setCurrentBrand()
        getAllBrands({})
      }
    },
    500, // eslint-disable-line
  )

  const updateBrand = useCallback(
    async (payload: UpdateBrandsPayload) => {
      const response = await dispatch(
        updateBrandThunk(removeEmptyProp(payload)),
      )
      if (response.payload?.id) {
        setCurrentBrand()
        getAllBrands({})
      }
    },
    [dispatch, saveBrand], // eslint-disable-line
  )

  const deleteBrand = debounce(
    (payload: number | string) => {
      dispatch(deleteBrandThunk({ id: payload }))
    },
    500, // eslint-disable-line
  )

  const setCurrentBrand = debounce((payload?: ListBrands) => {
    dispatch(BrandsActions.setCurrentBrandAction(payload || null))
  })

  return {
    getAllBrands,
    saveBrand,
    updateBrand,
    deleteBrand,
    setCurrentBrand,
  }
}
